var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58172 12.4183 0 8.00001 0C3.58173 0 0 3.58172 0 8C0 12.4183 3.58173 16 8.00001 16C12.4183 16 16 12.4183 16 8Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0371 6.3429C12.9741 5.73521 12.8386 5.06344 12.34 4.71041C11.9538 4.43664 11.4462 4.42652 10.9723 4.42708C9.97052 4.42708 8.9682 4.42877 7.96645 4.42933C7.00292 4.43046 6.03938 4.43102 5.07585 4.43214C4.67335 4.43214 4.28209 4.40122 3.90826 4.57549C3.58727 4.72502 3.33599 5.00948 3.18477 5.32597C2.97508 5.76613 2.93124 6.26476 2.90594 6.75159C2.85928 7.6381 2.86434 8.52686 2.92 9.41282C2.96103 10.0593 3.06503 10.7738 3.56478 11.1859C4.00776 11.5507 4.63287 11.5687 5.20739 11.5692C7.03102 11.5709 8.85521 11.5726 10.6794 11.5737C10.9133 11.5743 11.1572 11.5698 11.3956 11.5439C11.8644 11.4933 12.3113 11.359 12.6126 11.0116C12.9168 10.6614 12.9949 10.174 13.041 9.71245C13.1534 8.59264 13.1523 7.46215 13.0371 6.3429ZM6.91185 9.57022V6.4306L9.63043 8.00013L6.91185 9.57022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFYoutube);
export default __webpack_public_path__ + "static/media/f-youtube.8f1552b204401bdedf8db41c5444e25e.svg";
export { ForwardRef as ReactComponent };